module.exports = __webpack_public_path__ + "img/6@2x.af400c69.png";